import { useState, useEffect } from "react";
import "../../SalesMasterPages/AddLead/AddLead.css";
import React from "react";
import MiniDrawer from "../../../components/MiniDrawer/MiniDrawer";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import axios from "axios";
import Wrapper from "../../../components/UI/Wrapper";

const AddLead = () => {
  const [petTypeResponse, setPetTypeResponse] = useState([]);
  const [petBreedResponse, setPetBreedResponse] = useState([]);
  const [originCountryResponse, setOriginCountryResponse] = useState([]);
  const [destinationCountryResponse, setDestinationCountryResponse] = useState(
    []
  );
  const [errors, setErrors] = useState([]);
  const [originStateResponse, setOriginStateResponse] = useState([]);
  const [destinationStateResponse, setDestinationStateResponse] = useState([]);
  const [originCityResponse, setOriginCityResponse] = useState([]);
  const [destinationCityResponse, setDestinationCityResponse] = useState([]);
  const [successMessage, setSuccessMessage] = useState(null);
  const [serviceTypeResponse, setServiceTypeResponse] = useState([]);
  const baseAPI = process.env.REACT_APP_API_URL;

  const [formData, setFormData] = useState({
    Service_Type: "",
    Relocation_Date: "",
    First_Name: "",
    pickup_Address: "",
    alternate_number: "",
    Pet_gender: "",
    Last_Name: "",
    Email: "",
    Mobile_No: "",
    Number_Of_Pets: "",
    Pet_Type: "",
    Pet_Breed: "",
    Pet_DOB: "",
    Pet_Length: "",
    Pet_Width: "",
    Pet_Height: "",
    Pet_Photo_Standing: "",
    Pet_Photo_Sitting: "",
    VaccinationBook_Front: "",
    VaccinationBook_Back: "",
    Origin_Country: "",
    Origin_State: "",
    Origin_City: "",
    Origin_Pin: "",
    Destination_Country: "",
    Destination_State: "",
    Destination_City: "",
    Destination_Pin: "",
    Where_did_you_find_us: "",
    LeadSource: "",
    Other_Detail: "",
    createdBy: "Vishal",
    is_active: "true",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    if (errors[name]) {
      setErrors({ ...errors, [name]: null });
    }
  };

  /*---------------Validation Function-------*/

  const validateForm = () => {

    let errors = {};
    let FormIsValid = true;

    if (!formData.Service_Type) {
      FormIsValid = false;
      errors["Service_Type"] = "Service Type is required";
    }

    if (!formData.First_Name) {
      FormIsValid = false;
      errors["First_Name"] = "First Name is required";
    }

    // //phone number validation
    // if (!formData.Mobile_No) {
    //   FormIsValid = false;
    // } else {
    //   // Regular expression for basic international phone number validation (change according to your needs)
    //   const re = /^\+?[1-9]\d{1,14}$/;
    //   if (!re.test(formData.Mobile_No)) {
    //     FormIsValid = false;
    //     errors["Mobile_No"] = "Phone number is not valid";
    //   }
    // }

    // if (!formData.alternate_number) {
    //   FormIsValid = false;
    // } else {
    //   // Regular expression for basic international phone number validation (change according to your needs)
    //   const re = /^\+?[1-9]\d{1,14}$/;
    //   if (!re.test(formData.alternate_number)) {
    //     FormIsValid = false;
    //     errors["alternate_number"] = "Phone number is not valid";
    //   }
    // }

    if (!formData.LeadSource) {
      FormIsValid = false;
      errors["LeadSource"] = "Lead Source is required";
    }

    setErrors(errors);
    return FormIsValid;
  };

  const handleScrollTop = () => {
    // Scroll to the top of the page
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Optional: smooth scrolling animation
    });
  };

  // -------------------------------For saving File-------------------Start------------------------

  const uploadFile = async (file, fieldName) => {
    const reader = new FileReader();

    reader.onload = async () => {
      const byteImg = reader.result;
      const mediaData = {
        type: "image",
        url: byteImg,
      };
      const storedToken = JSON.parse(localStorage.getItem("token"));

      try {
        const response = await axios.post(
          `${baseAPI}UserPost/UploadImage`,
          mediaData,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        );

        if (response && response.data) {
          setFormData((prevFormData) => ({
            ...prevFormData,
            [fieldName]: response.data.data,
          }));
        }
      } catch (error) {
        console.error("Error posting data:", error);
      }
    };

    reader.readAsDataURL(file);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const fieldName = e.target.name;

    console.log(`Uploading file: ${file.name} for field: ${fieldName}`);

    uploadFile(file, fieldName);
  };
  // -------------------------------For saving File---------------End----------------------------

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      console.log("Validation failed");
      return;
    }

    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      // Make a POST request to your API endpoint
      const response = await axios.post(
        `${baseAPI}Admin/AddRelocationQuery`,
        formData, // Send formData as the request body
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );
      alert("Data successfully saved");
      // Optionally, reset the form
      setFormData({
        Service_Type: "",
        Relocation_Date: "",
        pickup_Address: "",
        alternate_number: "",
        Pet_gender: "",
        Owner_gender: "",
        First_Name: "",
        Last_Name: "",
        Email: "",
        Mobile_No: "",
        Number_Of_Pets: "",
        Pet_Type: "",
        Pet_Breed: "",
        Pet_DOB: "",
        Pet_Length: "",
        Pet_Width: "",
        Pet_Height: "",
        Pet_Photo_Standing: "",
        Pet_Photo_Sitting: "",
        VaccinationBook_Front: "",
        VaccinationBook_Back: "",
        Origin_Country: "",
        Origin_State: "",
        Origin_City: "",
        Origin_Pin: "",
        Destination_Country: "",
        Destination_State: "",
        Destination_City: "",
        Destination_Pin: "",
        Where_did_you_find_us: "",
        LeadSource: "",
        Other_Detail: "",

        createdBy: "Vishal",
        is_active: "true",
      });
    } catch (error) {
      // Handle errors (e.g., show an error message)
      console.error("Error posting data:", error);
    }
  };

  // -----------------------------------start for Pet Type-------------------------------------------------------------------
  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    if (storedToken) {
      axios
        .get(`${baseAPI}adminget/GEPetType?PetType=0`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          //console.log(response.data.data);
          setPetTypeResponse(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });

      axios
        .get(`${baseAPI}adminget/GETCountry?countryID=0`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          //console.log(response.data.data);
          setOriginCountryResponse(response.data.data);
          setDestinationCountryResponse(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });

      axios
        .get(`${baseAPI}adminget/GetServiceType`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          setServiceTypeResponse(response.data.data);

        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });





    }
  }, []);

  const handleSelectChangeOriginCountry = (event) => {
    // Handle the select input change and update the selected value
    formData.Origin_Country = event.target.value;
    const storedToken = JSON.parse(localStorage.getItem("token"));
    axios
      .get(
        `${baseAPI}adminget/GETState?stateID=0&countryID=` +
        formData.Origin_Country,
        {
          headers: {
            Authorization: "Bearer " + storedToken,
          },
        }
      )
      .then((response) => {
        setOriginStateResponse(response.data.data);
      });
  };

  const handleSelectChangeDestinationCountry = (event) => {
    // Handle the select input change and update the selected value
    formData.Destination_Country = event.target.value;
    const storedToken = JSON.parse(localStorage.getItem("token"));
    axios
      .get(
        `${baseAPI}adminget/GETState?stateID=0&countryID=` +
        formData.Destination_Country,
        {
          headers: {
            Authorization: "Bearer " + storedToken,
          },
        }
      )
      .then((response) => {
        setDestinationStateResponse(response.data.data);
      });
  };

  const handleSelectChangeDestinationState = (event) => {
    // Handle the select input change and update the selected value
    formData.Destination_State = event.target.value;
    const storedToken = JSON.parse(localStorage.getItem("token"));
    axios
      .get(
        `${baseAPI}adminget/GETCity?cityID=0&stateID=` +
        formData.Destination_State,
        {
          headers: {
            Authorization: "Bearer " + storedToken,
          },
        }
      )
      .then((response) => {
        setDestinationCityResponse(response.data.data);
      });
  };

  const handleSelectChangeOriginState = (event) => {
    // Handle the select input change and update the selected value
    formData.Origin_State = event.target.value;
    const storedToken = JSON.parse(localStorage.getItem("token"));
    axios
      .get(
        `${baseAPI}adminget/GETCity?cityID=0&stateID=` + formData.Origin_State,
        {
          headers: {
            Authorization: "Bearer " + storedToken,
          },
        }
      )
      .then((response) => {
        setOriginCityResponse(response.data.data);
      });
  };

  const handleSelectChangePetType = (event) => {
    // Handle the select input change and update the selected value
    formData.Pet_Type = event.target.value;
    const storedToken = JSON.parse(localStorage.getItem("token"));
    axios
      .get(
        `${baseAPI}adminget/GEPetBreedType?PetBreedID=0&PetType=` +
        formData.Pet_Type,
        {
          headers: {
            Authorization: "Bearer " + storedToken,
          },
        }
      )
      .then((response) => {
        setPetBreedResponse(response.data.data);
      });
    //setSelectedValue(event.target.value);
  };

  // -----------------------------------End for Pet Type-------------------------------------------------------------------

  // -----------------------------------start for Pet Breed-------------------------------------------------------------------

  const handleSelectChangePetBreed = (event) => {
    // Handle the select input change and update the selected value
    formData.Pet_Breed = event.target.value;
    //setSelectedValue(event.target.value);
  };

  return (
    <div className="app-container-AddLead">
      <MiniDrawer />
      <div className="container-fluid container-AddLead">
        <div className="country-header">
          <div>
            <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
              Add Lead | <HomeOutlinedIcon />{" "}
              <span style={{ fontSize: "20px" }}>&gt; Add Lead</span>
            </h1>
          </div>
          <div style={{ width: "8rem" }}>
            <select
              className="form-control"
              name="country"
              onChange={handleChange}
            >
              <option value="0">INDIA </option>
              <option value="1">DUBAI </option>
            </select>
          </div>
        </div>
        <Wrapper className="LeadDetail">
          {successMessage && (
            <div style={{ color: "green" }}>{successMessage}</div>
          )}
          <h2>Add Lead</h2>
          <form className="Lead-form" onSubmit={handleSubmit}>
            <table style={{ width: "100%" }}>
              <tbody>
                <tr className="space">
                  <td colSpan={3}></td>
                </tr>
                <tr className="tableHeading">
                  <td>Service Type</td>
                  <td>Relocation Date</td>
                </tr>
                <tr>
                  <td>
                    <select
                      className={`form-control ${errors.Service_Type ? "is-invalid" : ""
                        }`}
                      name="Service_Type"
                      value={formData.Service_Type}
                      onChange={handleChange}
                    >
                      <option value="0">Select an option</option>
                      {serviceTypeResponse !== null ? (
                        serviceTypeResponse.map((item) => (
                          <option value={item.service_type}>
                            {item.ServiceTypeName}
                          </option>
                        ))
                      ) : (
                        <p>empty</p>
                      )}
                    </select>
                  </td>
                  <td>
                    <input
                      type="date"
                      className="form-control"
                      name="Relocation_Date"
                      value={formData.Relocation_Date}
                      onChange={handleChange}
                    />
                  </td>
                </tr>

                <tr className="tableHeadingmain" style={{ backgroundColor: "#A3519F" }}>
                  <th colSpan={3}>Owner Details</th>
                </tr>

                <tr className="tableHeading">
                  <td>First Name*</td>
                  <td>Last Name</td>
                  <td>Email</td>
                </tr>
                <tr>
                  <td>
                    <input
                      className={`form-control ${errors.First_Name ? "is-invalid" : ""
                        }`}
                      type="text"
                      name="First_Name"
                      value={formData.First_Name}
                      placeholder="Please Enter*"
                      onChange={handleChange}
                    />
                  </td>
                  <td>
                    <input
                      className="form-control"
                      type="text"
                      name="Last_Name"
                      value={formData.Last_Name}
                      placeholder="Please Enter"
                      onChange={handleChange}
                    />
                  </td>
                  <td>
                    <input
                      className="form-control"
                      type="email"
                      name="Email"
                      value={formData.Email}
                      placeholder="Please Enter"
                      onChange={handleChange}
                    />
                  </td>
                </tr>

                <tr className="space">
                  <td colSpan={3}></td>
                </tr>

                <tr className="tableHeading">
                  <td>Phone No.</td>
                  <td>Alternative No.</td>
                  <td>Gender</td>
                </tr>
                <tr>
                  <td>
                    <input
                      className="form-control"
                      type="number"
                      name="Mobile_No"
                      value={formData.Mobile_No}
                      placeholder="Please Enter"
                      onChange={handleChange}
                    />
                  </td>
                  <td>
                    <input
                      className="form-control"
                      type="number"
                      name="alternate_number"
                      value={formData.alternate_number}
                      placeholder="Please Enter"
                      onChange={handleChange}
                    />
                  </td>
                  <td>
                    <select className="form-control">
                      <option value="0">Select Gender</option>
                      <option value="1">Male</option>
                      <option value="2">Female</option>
                    </select>
                  </td>
                </tr>

                <tr className="space">
                  <td colSpan={3}></td>
                </tr>

                <tr className="tableHeadingmain">
                  <th colSpan={3}>Pet Details</th>
                </tr>
                <tr className="tableHeading">
                  <td>Number of Pets</td>
                </tr>
                <tr>
                  <td>
                    <select
                      className="form-control"
                      name="Number_Of_Pets"
                      onChange={handleChange}
                      value={formData.Number_Of_Pets}
                    >
                      <option value="0">Select an option</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                    </select>
                  </td>
                </tr>
                {formData.Number_Of_Pets === "2" ? (
                  <>
                    {/* -------------Form change according to number of pet----------start----- */}
                    <h5
                      style={{
                        fontSize: "18px",
                        fontWeight: "600",
                        color: " #5B489D",
                        paddingTop: "3rem",
                      }}
                    >
                      FIRST PET
                    </h5>
                    <tr className="space">
                      <td colSpan={3}></td>
                    </tr>
                    <tr className="tableHeading">
                      <td>Date Of Birth</td>
                      <td>Pet Type</td>
                      <td>Pet Breed</td>
                    </tr>

                    <tr>
                      <td>
                        <input
                          type="date"
                          className="form-control"
                          name="Pet_DOB"
                          value={formData.Pet_DOB}
                          onChange={handleChange}
                        />
                      </td>
                      <td>
                        <select
                          className="form-control"
                          name="id"
                          onChange={handleSelectChangePetType}
                          value={formData.Pet_Type}
                        >
                          <option value="0" style={{ width: "5rem" }}>
                            Select an option
                          </option>
                          {petTypeResponse.map((item) => (
                            <option value={item.id}>{item.petType}</option>
                          ))}
                        </select>
                      </td>
                      <td>
                        <select
                          className="form-control"
                          name="id"
                          onChange={handleSelectChangePetBreed}
                        >
                          <option value="0">Select an option</option>
                          {petBreedResponse.map((item) => (
                            <option value={item.id}>{item.PetBreedType}</option>
                          ))}
                        </select>
                      </td>
                    </tr>
                    <tr className="space">
                      <td colSpan={3}></td>
                    </tr>
                    <tr className="tableHeading">
                      <td>Pet's Height (inch)</td>
                      <td>Pet's Length (inch)</td>
                      <td>Pet's Width (inch)</td>
                    </tr>

                    <tr>
                      <td>
                        <input
                          type="number"
                          className="form-control"
                          name="Pet_Height"
                          onChange={handleChange}
                          value={formData.Pet_Height}
                          min="0"
                          max="80"
                          placeholder="Enter pet height"
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          className="form-control"
                          name="Pet_Length"
                          onChange={handleChange}
                          value={formData.Pet_Length}
                          min="0"
                          max="80"
                          placeholder="Enter pet length"
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          className="form-control"
                          name="Pet_Width"
                          onChange={handleChange}
                          value={formData.Pet_Width}
                          min="0"
                          max="80"
                          placeholder="Enter pet width"
                        />
                      </td>
                    </tr>
                    <tr className="space">
                      <td colSpan={3}></td>
                    </tr>
                    <tr className="tableHeading">
                      <td>Pet's Photo (Standing)</td>
                      <td>Pet's Photo (Sitting)</td>
                    </tr>
                    <tr>
                      <td>
                        <input
                          type="file"
                          className="form-control"
                          name="Pet_Photo_Standing"
                          onChange={handleFileChange}
                        />
                      </td>
                      <td>
                        <input
                          type="file"
                          className="form-control"
                          name="Pet_Photo_Sitting"
                          onChange={handleFileChange}
                        />
                      </td>
                    </tr>

                    <tr className="space">
                      <td colSpan={3}></td>
                    </tr>

                    <tr className="tableHeading">
                      <td>Pet's Vaccination Book (Front)</td>
                      <td>Pet's Vaccination Book (Back)</td>
                    </tr>

                    <tr>
                      <td>
                        <input
                          type="file"
                          className="form-control"
                          name="VaccinationBook_Front"
                          onChange={handleFileChange}
                        />
                      </td>
                      <td>
                        <input
                          type="file"
                          className="form-control"
                          name="VaccinationBook_Back"
                          onChange={handleFileChange}
                        />
                      </td>
                    </tr>

                    <tr className="space">
                      <td colSpan={3}></td>
                    </tr>
                    {/* -------------Form change according to number of pet-------End-------- */}
                    {/* -------------Form change according to number of pet----------start----- */}
                    <h5
                      style={{
                        fontSize: "18px",
                        fontWeight: "600",
                        color: " #5B489D",
                        paddingTop: "3rem",
                      }}
                    >
                      SECOND PET
                    </h5>
                    <tr className="space">
                      <td colSpan={3}></td>
                    </tr>
                    <tr className="tableHeading">
                      <td>Date Of Birth</td>
                      <td>Pet Type</td>
                      <td>Pet Breed</td>
                    </tr>

                    <tr>
                      <td>
                        <input
                          type="date"
                          className="form-control"
                          name="Pet_DOB-2"
                          value={formData.Pet_DOB}
                          onChange={handleChange}
                        />
                      </td>
                      <td>
                        <select
                          className="form-control"
                          name="id"
                          onChange={handleSelectChangePetType}
                          value={formData.Pet_Type}
                        >
                          <option value="0" style={{ width: "5rem" }}>
                            Select an option
                          </option>
                          {petTypeResponse.map((item) => (
                            <option value={item.id}>{item.petType}</option>
                          ))}
                        </select>
                      </td>
                      <td>
                        <select
                          className="form-control"
                          name="id"
                          onChange={handleSelectChangePetBreed}
                        >
                          <option value="0">Select an option</option>
                          {petBreedResponse.map((item) => (
                            <option value={item.id}>{item.PetBreedType}</option>
                          ))}
                        </select>
                      </td>
                    </tr>

                    <tr className="space">
                      <td colSpan={3}></td>
                    </tr>

                    <tr className="tableHeading">
                      <td>Pet's Height (inch)</td>
                      <td>Pet's Length (inch)</td>
                      <td>Pet's Width (inch)</td>
                    </tr>

                    <tr>
                      <td>
                        <input
                          type="number"
                          className="form-control"
                          name="Pet_Height-2"
                          onChange={handleChange}
                          value={formData.Pet_Height}
                          min="0"
                          max="80"
                          placeholder="Enter pet Height"
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          className="form-control"
                          name="Pet_Length-2"
                          onChange={handleChange}
                          value={formData.Pet_Length}
                          min="0"
                          max="80"
                          placeholder="Enter pet Length"
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          className="form-control"
                          name="Pet_Width-2"
                          onChange={handleChange}
                          value={formData.Pet_Width}
                          min="0"
                          max="80"
                          placeholder="Enter pet Width"
                        />
                      </td>
                    </tr>

                    <tr className="space">
                      <td colSpan={3}></td>
                    </tr>

                    <tr className="tableHeading">
                      <td>Pet's Photo(Standing)</td>
                      <td>Pet's Photo(Sitting)</td>
                    </tr>

                    <tr>
                      <td>
                        <input
                          type="file"
                          className="form-control"
                          name="Pet_Photo_Standing-2"
                          onChange={handleFileChange}
                        />
                      </td>
                      <td>
                        <input
                          type="file"
                          className="form-control"
                          name="Pet_Photo_Sitting-2"
                          onChange={handleFileChange}
                        />
                      </td>
                    </tr>

                    <tr className="space">
                      <td colSpan={3}></td>
                    </tr>

                    <tr className="tableHeading">
                      <td>Pet's Vaccination Book (Front)</td>
                      <td>Pet's Vaccination Book (Back)</td>
                    </tr>

                    <tr>
                      <td>
                        <input
                          type="file"
                          className="form-control"
                          name="VaccinationBook_Front-2"
                          onChange={handleFileChange}
                        />
                      </td>
                      <td>
                        <input
                          type="file"
                          className="form-control"
                          name="VaccinationBook_Back-2"
                          onChange={handleFileChange}
                        />
                      </td>
                    </tr>

                    <tr className="space">
                      <td colSpan={3}></td>
                    </tr>
                    {/* -------------Form change according to number of pet-------End-------- */}
                  </>
                ) : (
                  <>
                    {/* -------------Form change according to number of pet----------start----- */}
                    <tr className="space">
                      <td colSpan={3}></td>
                    </tr>
                    <tr className="tableHeading">
                      <td>Date Of Birth</td>
                      <td>Pet Type</td>
                      <td>Pet Breed</td>
                    </tr>

                    <tr>
                      <td>
                        <input
                          type="date"
                          className="form-control"
                          name="Pet_DOB"
                          value={formData.Pet_DOB}
                          onChange={handleChange}
                        />
                      </td>
                      <td>
                        <select
                          className="form-control"
                          name="id"
                          onChange={handleSelectChangePetType}
                          value={formData.Pet_Type}
                        >
                          <option value="0" style={{ width: "5rem" }}>
                            Select an option
                          </option>
                          {petTypeResponse.map((item) => (
                            <option value={item.id}>{item.petType}</option>
                          ))}
                        </select>
                      </td>
                      <td>
                        <select
                          className="form-control"
                          name="id"
                          onChange={handleSelectChangePetBreed}
                        >
                          <option value="0">Select an option</option>
                          {petBreedResponse.map((item) => (
                            <option value={item.id}>{item.PetBreedType}</option>
                          ))}
                        </select>
                      </td>
                    </tr>

                    <tr className="space">
                      <td colSpan={3}></td>
                    </tr>

                    <tr className="tableHeading">
                      <td>Pet's Height (inch)</td>
                      <td>Pet's Length (inch)</td>
                      <td>Pet's Width (inch)</td>
                    </tr>

                    <tr>
                      <td>
                        <input
                          type="number"
                          className="form-control"
                          name="Pet_Height"
                          onChange={handleChange}
                          value={formData.Pet_Height}
                          min="0"
                          max="80"
                          placeholder="Enter pet Height"
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          className="form-control"
                          name="Pet_Length"
                          onChange={handleChange}
                          value={formData.Pet_Length}
                          min="0"
                          max="80"
                          placeholder="Enter pet Length"
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          className="form-control"
                          name="Pet_Width"
                          onChange={handleChange}
                          value={formData.Pet_Width}
                          min="0"
                          max="80"
                          placeholder="Enter pet width"
                        />
                      </td>
                    </tr>

                    <tr className="space">
                      <td colSpan={3}></td>
                    </tr>

                    <tr className="tableHeading">
                      <td>Pet's Photo(Standing)</td>
                      <td>Pet's Photo(Sitting)</td>
                    </tr>

                    <tr>
                      <td>
                        <input
                          type="file"
                          className="form-control"
                          name="Pet_Photo_Standing"
                          onChange={handleFileChange}
                        />
                      </td>
                      <td>
                        <input
                          type="file"
                          className="form-control"
                          name="Pet_Photo_Sitting"
                          onChange={handleFileChange}
                        />
                      </td>
                    </tr>

                    <tr className="space">
                      <td colSpan={3}></td>
                    </tr>

                    <tr className="tableHeading">
                      <td>Pet's Vaccination Book (Front)</td>
                      <td>Pet's Vaccination Book (Back)</td>
                    </tr>

                    <tr>
                      <td>
                        <input
                          type="file"
                          className="form-control"
                          name="VaccinationBook_Front"
                          onChange={handleFileChange}
                        />
                      </td>
                      <td>
                        <input
                          type="file"
                          className="form-control"
                          name="VaccinationBook_Back"
                          onChange={handleFileChange}
                        />
                      </td>
                    </tr>

                    <tr className="space">
                      <td colSpan={3}></td>
                    </tr>
                    {/* -------------Form change according to number of pet-------End-------- */}
                  </>
                )}

                <tr className="tableHeadingmain">
                  <th colSpan={3}>Travel Details</th>
                </tr>

                <tr className="tableHeading">
                  <td>Origin Country</td>
                  <td>Origin State</td>
                  <td>Origin City</td>
                </tr>

                <tr>
                  <td>
                    <select
                      className="form-control"
                      name="ddlOrigin_Country"
                      onChange={handleSelectChangeOriginCountry}
                      value={formData.Origin_Country}
                    >
                      <option value="0">Select an option</option>
                      {originCountryResponse.map((item) => (
                        <option value={item.id}>{item.name}</option>
                      ))}
                    </select>
                  </td>
                  <td>
                    <select
                      className="form-control"
                      name="ddlOrigin_State"
                      onChange={handleSelectChangeOriginState}
                      value={formData.Origin_State}
                    >
                      <option value="0">Select an option</option>
                      {originStateResponse.map((item) => (
                        <option value={item.state_id}>{item.stateName}</option>
                      ))}
                    </select>
                  </td>
                  <td>
                    <select
                      className="form-control"
                      name="Origin_City"
                      value={formData.Origin_City}
                      onChange={handleChange}
                    >
                      <option value="0">Select an option</option>
                      {originCityResponse.map((item) => (
                        <option value={item.id}>{item.name}</option>
                      ))}
                    </select>
                  </td>
                </tr>

                <tr className="space">
                  <td colSpan={3}></td>
                </tr>

                <tr className="tableHeading">
                  <td>Origin Pin</td>
                  <td>Destination Country</td>
                  <td>Destination State</td>
                </tr>

                <tr>
                  <td>
                    <input
                      className="form-control"
                      type="number"
                      name="Origin_Pin"
                      value={formData.Origin_Pin}
                      placeholder="Please Enter"
                      onChange={handleChange}
                    />
                  </td>
                  <td>
                    <select
                      className="form-control"
                      name="ddlDestination_Country"
                      onChange={handleSelectChangeDestinationCountry}
                      value={formData.Destination_Country}
                    >
                      <option value="0" style={{ width: "5rem" }}>
                        Select an option
                      </option>
                      {destinationCountryResponse.map((item) => (
                        <option value={item.id}>{item.name}</option>
                      ))}
                    </select>
                  </td>
                  <td>
                    <select
                      className="form-control"
                      name="ddlDestination_State"
                      onChange={handleSelectChangeDestinationState}
                      value={formData.Destination_State}
                    >
                      <option value="0">Select an option</option>
                      {destinationStateResponse.map((item) => (
                        <option value={item.state_id}>{item.stateName}</option>
                      ))}
                    </select>
                  </td>
                </tr>

                <tr className="space">
                  <td colSpan={3}></td>
                </tr>

                <tr className="tableHeading">
                  <td>Destination City</td>
                  <td>Destination Pin</td>
                  <td>Pickup Address</td>
                </tr>

                <tr>
                  <td>
                    <select
                      className="form-control"
                      name="Destination_City"
                      value={formData.Destination_City}
                      onChange={handleChange}
                    >
                      <option value="0">Select an option</option>
                      {destinationCityResponse.map((item) => (
                        <option value={item.id}>{item.name}</option>
                      ))}
                    </select>
                  </td>
                  <td>
                    <input
                      className="form-control"
                      type="number"
                      name="Destination_Pin"
                      value={formData.Destination_Pin}
                      placeholder="Please Enter"
                      onChange={handleChange}
                    />
                  </td>
                  <td>
                    <input
                      className="form-control"
                      type="text"
                      name="pickup_Address"
                      value={formData.pickup_Address}
                      placeholder="Please Enter"
                      onChange={handleChange}
                    />
                  </td>
                </tr>

                <tr className="space">
                  <td colSpan={3}></td>
                </tr>
                <hr style={{ width: "269%" }} />
                <tr className="space">
                  <td colSpan={3}></td>
                </tr>

                <tr className="tableHeading">
                  <td>Where did you find us</td>
                  <td>Lead Source</td>
                </tr>

                <tr>
                  <td>
                    <select
                      className="form-control"
                      name="Where_did_you_find_us"
                      onChange={handleChange}
                    >
                      <option value="0">Select an option</option>
                      <option value="1">Facebook</option>
                      <option value="2">Instagram</option>
                      <option value="3">LinkedIn</option>
                      <option value="4">Through existing user</option>
                      <option value="5">Friends and Family</option>
                      <option value="6">While searching on google</option>
                    </select>
                  </td>
                  <td>
                    <select
                      className={`form-control ${errors.LeadSource ? "is-invalid" : ""
                        }`}
                      name="LeadSource"
                      onChange={handleChange}
                      value={formData.LeadSource}
                    >
                      <option value="0">Please Select*</option>
                      <option value="1">Web Query</option>
                      <option value="2">Email</option>
                      <option value="3">IVR</option>
                      <option value="4">Others</option>
                      <option value="5">IPATA</option>
                      <option value="6">Campaign</option>
                    </select>
                  </td>
                </tr>
                <tr className="space">
                  <td colSpan={3}></td>
                </tr>

                <tr className="tableHeading">
                  <td>Other Details</td>
                </tr>

                <tr>
                  <td>
                    <textarea
                      style={{ width: "265%", height: "300%" }}
                      type="text"
                      className="form-control"
                      name="Other_Detail"
                      value={formData.Other_Detail}
                      placeholder="Please Enter"
                      onChange={handleChange}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
            <br />

            <div className="reset-addLead-button">
              <button
                type="submit"
                style={{
                  marginRight: "10px",
                  backgroundColor: "#5B489D",
                  color: "white",
                }}
                onClick={handleScrollTop}
              >
                Add Lead
              </button>
            </div>
          </form>
        </Wrapper>
        <br />
      </div>
    </div>
  );
};

export default AddLead;
